/**
 * TIPS AND TRICKS FOR CONTRIBUTORS
 * 1) Memorize the layering of body parts. Hands are higher than arms, feet higher than legs
 * 2) Generally you will want to avoid lower pri items on the same layer sticking out on seams if your object is skintight.
 * In general, this is accomplished by having higher priority items cover more of the original
 */


AddModel({
	Name: "LeatherMittenLeft",
	Folder: "Mittens",
	Parent: "LeatherMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "LeatherLeft", Layer: "MittenLeft", Pri: 100,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			InheritColor: "Mitten",
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "BandLeft", Layer: "MittenLeft", Pri: 100.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LeatherLeft",
			NoOverride: true,
			InheritColor: "Band",
		},
		{ Name: "LockLeft", Layer: "MittenLeft", Pri: 100.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LeatherLeft",
			NoOverride: true,
			InheritColor: "Lock",
		},


	])
});

AddModel({
	Name: "LeatherMittenRight",
	Folder: "Mittens",
	Parent: "LeatherMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "LeatherRight", Layer: "MittenRight", Pri: 100,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			InheritColor: "Mitten",
		},
		{ Name: "BandRight", Layer: "MittenRight", Pri: 100.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LeatherRight",
			NoOverride: true,
			InheritColor: "Band",
		},
		{ Name: "LockRight", Layer: "MittenRight", Pri: 100.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LeatherRight",
			NoOverride: true,
			InheritColor: "Lock",
		},
	])
});

AddModel({
	Name: "LeatherPawMittenLeft",
	Folder: "Mittens",
	Parent: "LeatherMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("LeatherMittenLeft"),
		{ Name: "PawLeft", Layer: "MittenLeft", Pri: 100.3,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LeatherLeft",
			NoOverride: true,
			InheritColor: "Paw",
		},
	])
});
AddModel({
	Name: "LeatherPawMittenRight",
	Folder: "Mittens",
	Parent: "LeatherMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("LeatherMittenRight"),
		{ Name: "PawRight", Layer: "MittenRight", Pri: 100.3,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LeatherRight",
			NoOverride: true,
			InheritColor: "Paw",
		},
	])
});

AddModel({
	Name: "LatexMittenLeft",
	Folder: "Mittens",
	Parent: "LatexMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "LatexLeft", Layer: "MittenLeft", Pri: 100,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			InheritColor: "Mitten",
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "ZipperLeft", Layer: "MittenLeft", Pri: 100.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LatexLeft",
			NoOverride: true,
			InheritColor: "Zipper",
		},

	])
});

AddModel({
	Name: "LatexMittenRight",
	Folder: "Mittens",
	Parent: "LatexMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "LatexRight", Layer: "MittenRight", Pri: 100,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			InheritColor: "Mitten",
		},
		{ Name: "ZipperRight", Layer: "MittenRight", Pri: 100.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LatexRight",
			NoOverride: true,
			InheritColor: "Zipper",
		},
	])
});

AddModel({
	Name: "LatexMittens",
	Folder: "Mittens",
	TopLevel: true,
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("LatexMittenLeft"),
		...GetModelLayers("LatexMittenRight"),
	])
});


AddModel({
	Name: "LeatherMittens",
	Folder: "Mittens",
	TopLevel: true,
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("LeatherMittenLeft"),
		...GetModelLayers("LeatherMittenRight"),
	])
});

AddModel({
	Name: "LeatherPawMittens",
	Folder: "Mittens",
	TopLevel: false,
	Parent: "LeatherMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("LeatherPawMittenLeft"),
		...GetModelLayers("LeatherPawMittenRight"),
	])
});

AddModel({
	Name: "LongMittenLeft",
	Folder: "Mittens",
	Parent: "LongMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "LongMittenLeft", Layer: "MittenLeft", Pri: 100,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			InheritColor: "Mitten",
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "ForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: -1,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Mitten",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "BandLeft", Layer: "MittenLeft", Pri: 100.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "Band",
		},
		{ Name: "LockLeft", Layer: "MittenLeft", Pri: 100.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "Lock",
		},
	])
});

AddModel({
	Name: "LongMittenRight",
	Folder: "Mittens",
	Parent: "LongMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "LongMittenRight", Layer: "MittenRight", Pri: 100,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			InheritColor: "Mitten",
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "ForeLongMittenRight", Layer: "ForeMittenRight", Pri: -1,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Mitten",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
		},
		{ Name: "BandRight", Layer: "MittenRight", Pri: 100.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "Band",
		},
		{ Name: "LockRight", Layer: "MittenRight", Pri: 100.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "Lock",
		},
	])
});

AddModel({
	Name: "LongMittens",
	Folder: "Mittens",
	TopLevel: true,
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("LongMittenLeft"),
		...GetModelLayers("LongMittenRight"),
	])
});



AddModel({
	Name: "CyberLongMittenLeft",
	Folder: "CyberMitts",
	Parent: "LongMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "CapForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			HideWhenOverridden: true,
			InheritColor: "Cap",
		},
		{ Name: "CapLongMittenLeft", Layer: "MittenLeft", Pri: 120,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			HideWhenOverridden: true,
			InheritColor: "Cap",
		},
		{ Name: "LongMittenLeft", Layer: "MittenLeft", Pri: 120.05,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			InheritColor: "Mitten",
			NoOverride: true,
		},
		{ Name: "ForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.05,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Mitten",
			NoOverride: true,
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "CuffForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "CapForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "CuffLongMittenLeft", Layer: "MittenLeft", Pri: 120.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "CapLongMittenLeft",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "DisplayForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.2,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "CapForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "DisplayLongMittenLeft", Layer: "MittenLeft", Pri: 120.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "CapLongMittenLeft",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "LockForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.3,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "CapForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "LockLongMittenLeft", Layer: "MittenLeft", Pri: 120.3,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "CapLongMittenLeft",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "GlowForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.4,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "CapForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Glow",
		},
		{ Name: "GlowLongMittenLeft", Layer: "MittenLeft", Pri: 120.4,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "CapLongMittenLeft",
			NoOverride: true,
			InheritColor: "Glow",
		},
		{ Name: "StrapsForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "StrapsLongMittenLeft", Layer: "MittenLeft", Pri: 120.1,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "UpperCuffLongMittenLeft", Layer: "MittenLeft", Pri: 120.1,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "UpperCuff",
		},
		{ Name: "UpperDisplayLongMittenLeft", Layer: "MittenLeft", Pri: 120.2,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "UpperDisplay",
		},
		{ Name: "UpperLockLongMittenLeft", Layer: "MittenLeft", Pri: 120.3,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "UpperLock",
		},
		{ Name: "UpperGlowLongMittenLeft", Layer: "MittenLeft", Pri: 120.4,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "UpperGlow",
		},
	])
});

AddModel({
	Name: "CyberLongMittenRight",
	Folder: "CyberMitts",
	Parent: "CyberLongMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "CapForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			HideWhenOverridden: true,
			InheritColor: "Cap",
		},
		{ Name: "CapLongMittenRight", Layer: "MittenRight", Pri: 120,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			HideWhenOverridden: true,
			InheritColor: "Cap",
		},
		{ Name: "LongMittenRight", Layer: "MittenRight", Pri: 120.05,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			InheritColor: "Mitten",
			EraseSprite: "Mitts",
			NoOverride: true,
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "ForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.05,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Mitten",
			NoOverride: true,
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "CuffForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "CapForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "CuffLongMittenRight", Layer: "MittenRight", Pri: 120.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "CapLongMittenRight",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "DisplayForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.2,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "CapForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "DisplayLongMittenRight", Layer: "MittenRight", Pri: 120.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "CapLongMittenRight",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "LockForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.3,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "CapForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "LockLongMittenRight", Layer: "MittenRight", Pri: 120.3,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "CapLongMittenRight",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "GlowForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.4,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "CapForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Glow",
		},
		{ Name: "GlowLongMittenRight", Layer: "MittenRight", Pri: 120.4,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "CapLongMittenRight",
			NoOverride: true,
			InheritColor: "Glow",
		},

		{ Name: "StrapsForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "StrapsLongMittenRight", Layer: "MittenRight", Pri: 120.1,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "UpperCuffLongMittenRight", Layer: "MittenRight", Pri: 120.1,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "UpperCuff",
		},
		{ Name: "UpperDisplayLongMittenRight", Layer: "MittenRight", Pri: 120.2,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "UpperDisplay",
		},
		{ Name: "UpperLockLongMittenRight", Layer: "MittenRight", Pri: 120.3,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "UpperLock",
		},
		{ Name: "UpperGlowLongMittenRight", Layer: "MittenRight", Pri: 120.4,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "UpperGlow",
		},
	])
});

AddModel({
	Name: "CyberLongMittens",
	Folder: "CyberMitts",
	TopLevel: true,
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("CyberLongMittenLeft"),
		...GetModelLayers("CyberLongMittenRight"),
	])
});




AddModel({
	Name: "CyberMittenLeft",
	Folder: "CyberMitts",
	Parent: "CyberMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "MittenLeft", Layer: "MittenLeft", Pri: 130,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			InheritColor: "Mitten",
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "ForeMittenLeft", Layer: "ForeMittenLeft", Pri: 30,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Mitten",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
		},
		{ Name: "CuffForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 30.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeMittenLeft",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "CuffLongMittenLeft", Layer: "MittenLeft", Pri: 130.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "MittenLeft",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "DisplayForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 30.2,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeMittenLeft",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "DisplayLongMittenLeft", Layer: "MittenLeft", Pri: 130.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "MittenLeft",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "LockForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 30.3,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeMittenLeft",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "LockLongMittenLeft", Layer: "MittenLeft", Pri: 130.3,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "MittenLeft",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "GlowForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 30.4,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeMittenLeft",
			NoOverride: true,
			InheritColor: "Glow",
		},
		{ Name: "GlowLongMittenLeft", Layer: "MittenLeft", Pri: 130.4,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "MittenLeft",
			NoOverride: true,
			InheritColor: "Glow",
		},
		{ Name: "CapForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 30.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeMittenLeft",
			NoOverride: true,
			InheritColor: "Cap",
		},
		{ Name: "CapLongMittenLeft", Layer: "MittenLeft", Pri: 130.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "MittenLeft",
			NoOverride: true,
			InheritColor: "Cap",
		},
	])
});

AddModel({
	Name: "CyberMittenRight",
	Folder: "CyberMitts",
	Parent: "CyberMittens",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "MittenRight", Layer: "MittenRight", Pri: 130,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			InheritColor: "Mitten",
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
		},
		{ Name: "ForeMittenRight", Layer: "ForeMittenRight", Pri: 30,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Mitten",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
		},
		{ Name: "CuffForeLongMittenRight", Layer: "ForeMittenRight", Pri: 30.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeMittenRight",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "CuffLongMittenRight", Layer: "MittenRight", Pri: 130.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "MittenRight",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "DisplayForeLongMittenRight", Layer: "ForeMittenRight", Pri: 30.2,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeMittenRight",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "DisplayLongMittenRight", Layer: "MittenRight", Pri: 130.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "MittenRight",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "LockForeLongMittenRight", Layer: "ForeMittenRight", Pri: 30.3,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeMittenRight",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "LockLongMittenRight", Layer: "MittenRight", Pri: 130.3,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "MittenRight",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "GlowForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.4,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeMittenRight",
			NoOverride: true,
			InheritColor: "Glow",
		},
		{ Name: "GlowLongMittenRight", Layer: "MittenRight", Pri: 130.4,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "MittenRight",
			NoOverride: true,
			InheritColor: "Glow",
		},
		{ Name: "CapForeLongMittenRight", Layer: "ForeMittenRight", Pri: 30.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeMittenRight",
			NoOverride: true,
			InheritColor: "Cap",
		},
		{ Name: "CapLongMittenRight", Layer: "MittenRight", Pri: 130.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "MittenRight",
			NoOverride: true,
			InheritColor: "Cap",
		},
	])
});

AddModel({
	Name: "CyberMittens",
	Folder: "CyberMitts",
	TopLevel: true,
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("CyberMittenLeft"),
		...GetModelLayers("CyberMittenRight"),
	])
});



AddModel({
	Name: "CyberArmLeft",
	Folder: "CyberArms",
	Parent: "CyberArms",
	Categories: ["Gloves", "Sleeves"],
	Layers: ToLayerMap([
		{ Name: "LongMittenLeft", Layer: "MittenLeft", Pri: 120,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			InheritColor: "Mitten",
			NoOverride: true,
		},
		{ Name: "ForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Mitten",
			NoOverride: true,
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
		},
		{ Name: "CuffForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "CuffLongMittenLeft", Layer: "MittenLeft", Pri: 120.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "DisplayForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.2,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "DisplayLongMittenLeft", Layer: "MittenLeft", Pri: 120.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "LockForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.3,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "LockLongMittenLeft", Layer: "MittenLeft", Pri: 120.3,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "GlowForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.4,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Glow",
		},
		{ Name: "GlowLongMittenLeft", Layer: "MittenLeft", Pri: 120.4,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "Glow",
		},


		{ Name: "StrapsForeLongMittenLeft", Layer: "ForeMittenLeft", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft"},
			TieToLayer: "ForeLongMittenLeft",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "StrapsLongMittenLeft", Layer: "MittenLeft", Pri: 120.1,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "UpperCuffLongMittenLeft", Layer: "MittenLeft", Pri: 120.1,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "UpperCuff",
		},
		{ Name: "UpperDisplayLongMittenLeft", Layer: "MittenLeft", Pri: 120.2,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "UpperDisplay",
		},
		{ Name: "UpperLockLongMittenLeft", Layer: "MittenLeft", Pri: 120.3,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "UpperLock",
		},
		{ Name: "UpperGlowLongMittenLeft", Layer: "MittenLeft", Pri: 120.4,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenLeft", Front: "ForeMittenLeft"},
			TieToLayer: "LongMittenLeft",
			NoOverride: true,
			InheritColor: "UpperGlow",
		},
	])
});

AddModel({
	Name: "CyberArmRight",
	Folder: "CyberArms",
	Parent: "CyberArms",
	Categories: ["Gloves", "Sleeves"],
	Layers: ToLayerMap([
		{ Name: "LongMittenRight", Layer: "MittenRight", Pri: 120,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			InheritColor: "Mitten",
			NoOverride: true,
		},
		{ Name: "ForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Mitten",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			NoOverride: true,
		},
		{ Name: "CuffForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "CuffLongMittenRight", Layer: "MittenRight", Pri: 120.1,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "Cuff",
		},
		{ Name: "DisplayForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.2,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "DisplayLongMittenRight", Layer: "MittenRight", Pri: 120.2,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "LockForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.3,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "LockLongMittenRight", Layer: "MittenRight", Pri: 120.3,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
		{ Name: "GlowForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.4,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Glow",
		},
		{ Name: "GlowLongMittenRight", Layer: "MittenRight", Pri: 120.4,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Boxtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "Glow",
		},



		{ Name: "StrapsForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeLongMittenRight",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "StrapsLongMittenRight", Layer: "MittenRight", Pri: 120.1,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "UpperCuffForeLongMittenRight", Layer: "ForeMittenRight", Pri: 20.1,
			Poses: ToMap([...FOREARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			TieToLayer: "ForeLongMittenRight",
			NoOverride: true,
			InheritColor: "UpperCuff",
		},
		{ Name: "UpperCuffLongMittenRight", Layer: "MittenRight", Pri: 120.1,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "UpperCuff",
		},
		{ Name: "UpperDisplayLongMittenRight", Layer: "MittenRight", Pri: 120.2,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "UpperDisplay",
		},
		{ Name: "UpperLockLongMittenRight", Layer: "MittenRight", Pri: 120.3,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "UpperLock",
		},
		{ Name: "UpperGlowLongMittenRight", Layer: "MittenRight", Pri: 120.4,
			Poses: ToMap([...ARMPOSES]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossMittenRight", Front: "ForeMittenRight"},
			TieToLayer: "LongMittenRight",
			NoOverride: true,
			InheritColor: "UpperGlow",
		},
	])
});

AddModel({
	Name: "CyberArms",
	Folder: "CyberArms",
	TopLevel: true,
	Categories: ["Gloves", "Sleeves"],
	Layers: ToLayerMap([
		...GetModelLayers("CyberArmLeft"),
		...GetModelLayers("CyberArmRight"),
	])
});


AddModel({
	Name: "LatexDollMittLeft",
	Folder: "LatexMittens",
	Parent: "LatexDollMitts",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "LatexLeft", Layer: "MittenLeft", Pri: 110,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Front: "ForeMittenLeft"},
			InheritColor: "Mitten",
			EraseSprite: "Mitts",
			EraseLayers: ToMap(["Mitts"]),
			HideWhenOverridden: true,
		},

	])
});

AddModel({
	Name: "LatexDollMittRight",
	Folder: "LatexMittens",
	Parent: "LatexDollMitts",
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		{ Name: "LatexRight", Layer: "MittenRight", Pri: 110,
			Poses: ToMapSubtract([...ARMPOSES], ["Wristtie", "Up"]),
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Front: "ForeMittenRight"},
			InheritColor: "Mitten",
			HideWhenOverridden: true,
		},
	])
});

AddModel({
	Name: "LatexDollMitts",
	Folder: "LatexMittens",
	TopLevel: true,
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("LatexDollMittLeft"),
		...GetModelLayers("LatexDollMittRight"),
	])
});


AddModel({
	Name: "LatexDollMittsLong",
	Folder: "LatexMittens",
	TopLevel: true,
	Categories: ["Gloves", "Mittens", "Restraints"],
	Restraint: true,
	AddPose: ["Mittens"],
	Layers: ToLayerMap([
		...GetModelLayers("LatexDollMittLeft"),
		...GetModelLayers("LatexDollMittRight"),
		...GetModelLayers("CyberArmLeft", undefined, undefined, undefined, undefined, undefined, "CyberArms"),
		...GetModelLayers("CyberArmRight", undefined, undefined, undefined, undefined, undefined, "CyberArms"),
	])
});




//AddModel(GetModelFashionVersion("LeatherMittenRight", true));
//AddModel(GetModelFashionVersion("LeatherMittenLeft", true));
AddModel(GetModelFashionVersion("LeatherMittens", true));
//AddModel(GetModelFashionVersion("LeatherPawMittenRight", true));
//AddModel(GetModelFashionVersion("LeatherPawMittenLeft", true));
AddModel(GetModelFashionVersion("LeatherPawMittens", true));
//AddModel(GetModelFashionVersion("LatexMittenRight", true));
//AddModel(GetModelFashionVersion("LatexMittenLeft", true));
AddModel(GetModelFashionVersion("LatexMittens", true));
AddModel(GetModelFashionVersion("LatexDollMitts", true));
//AddModel(GetModelFashionVersion("LongMittenRight", true));
//AddModel(GetModelFashionVersion("LongMittenLeft", true));
AddModel(GetModelFashionVersion("LongMittens", true));
AddModel(GetModelFashionVersion("CyberLongMittens", true));
AddModel(GetModelFashionVersion("CyberMittens", true));



